import { Button } from "PFComponents/button";
import Pill from "PFComponents/pill/pill";
import { useEditAccessRequest } from "PFCore/hooks/queries/admin/access_requests/use_edit_access_request";
import { AccessRequest, AccessRequestStatus } from "PFTypes/access_request";
import React from "react";
import { useTranslation } from "react-i18next";

import css from "./access_requests.module.scss";

export const useAccessRequestsColumns = () => {
  const { t } = useTranslation(["admin", "translation"]);
  const { mutate: mutateAccessRequest } = useEditAccessRequest();

  const handleStatusChange = (accessRequest: AccessRequest, status: AccessRequestStatus) => {
    if (
      status === "accepted"
        ? confirm(t("admin:accessRequests.confirm.accept", { email: accessRequest.email }))
        : confirm(t("admin:accessRequests.confirm.reject"))
    ) {
      mutateAccessRequest({ id: accessRequest.id, status });
    }
  };

  const statusRenderer = (accessRequest: AccessRequest) => {
    switch (accessRequest.status) {
      case "accepted":
        return <Pill small>{t("translation:accepted")}</Pill>;
      case "rejected":
        return (
          <div className={css.status}>
            <Button small onClick={() => handleStatusChange(accessRequest, "accepted")}>
              {t("translation:accept")}
            </Button>
            <Pill small>{t("translation:rejected")}</Pill>
          </div>
        );
      case "pending":
        return (
          <div className={css.status}>
            <Button small onClick={() => handleStatusChange(accessRequest, "accepted")}>
              {t("translation:accept")}
            </Button>
            <Button small kind="danger" onClick={() => handleStatusChange(accessRequest, "rejected")}>
              {t("translation:reject")}
            </Button>
          </div>
        );
    }
  };

  const columns = [
    {
      headerName: t("admin:accessRequests.list.companyEmail"),
      cellKey: "email"
    },
    {
      headerName: t("admin:accessRequests.list.fullName"),
      cellKey: "name"
    },
    {
      headerName: t("admin:accessRequests.list.company"),
      cellKey: "company"
    },
    {
      headerName: t("admin:accessRequests.list.status"),
      renderCell: statusRenderer,
      narrow: true
    }
  ];

  return columns;
};
